/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { Modal, useMediaQuery } from '@mui/material';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSetupModal } from '../../store/setup-modal/setup-modal.slice';
import { useStationSocket } from '../../hooks/useStationSocket';
import { useRedirectHomeOnNotFound } from '../../hooks/useRedirectHomeOnNotFound';
import { IStation } from '../../api/station/types';

export const ModalWithNavigation = () => {
    const isDesktop = useMediaQuery('(min-width:600px)');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { stationId, connectorId } = useParams();

    const { station, isLoading: stationLoading, error: stationError, locationId } = useStationSocket(
        stationId
    );

    const stationData = station?.data;

    useRedirectHomeOnNotFound(stationError, stationLoading);

    useEffect(() => {
        if (stationLoading || !stationData || !connectorId) return;

        const foundConnector = stationData.connectors?.find(c => c._id === connectorId);

        if (!foundConnector) {
            navigate('/');
            return;
        }

        const isEligible =
            stationData.isBusinessEnabled === true &&
            stationData.user?.stripe?.isReadyForIncomingPayments === true;

        if (!isEligible) {
            navigate('/');
            return;
        }

        dispatch(
            setSetupModal({
                connector: {
                    ...foundConnector,
                    station: stationData,
                },
            })
        );
    }, [stationData, connectorId, stationId, stationLoading, dispatch, navigate]);

    return (
        <Modal
            sx={{
                '& 	.MuiModal-backdrop': {
                    background: '#15457580',
                    backgroundColor: isDesktop ? '#15457580' : '#ffffff',
                    backdropFilter: 'blur(50px)',
                },
                '&': {
                    zIndex: 10001,
                },
            }}
            open={true}
            slotProps={{
                backdrop: {
                    timeout: 300,
                },
            }}
            closeAfterTransition
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Outlet
                context={{
                    stationLoading,
                    locationId,
                    station: stationData as IStation | undefined,
                }}
            />
        </Modal>
    );
};
